import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { login as apiLogin, register as apiRegister } from "../services/api";
import "./LoginModal.css";
import "../../src/style.css";
import logo from "../images/avrnhh-transparent.png";

const LoginModal = ({ onClose }) => {
  const { login } = useAuth();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Handle Login
  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter both email and password");
      return;
    }

    setLoading(true);
    try {
      const data = await apiLogin({ email, password });
      if (data.token) {
        login(data.token, data.user);
        alert("Login successful!");
        onClose();
        window.location.reload(); // Reload to update UI
      } else {
        alert(data.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("Login error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Unable to login. Please try again later.";
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle Registration
  const handleRegister = async () => {
    if (!name || !email || !password) {
      alert("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const data = await apiRegister({ name, email, password });
      if (data.token) {
        login(data.token, data.user);
        alert("Registration successful!");
        onClose();
        window.location.reload(); // Reload to update UI
      } else {
        alert(data.message || "Registration failed. Try again.");
      }
    } catch (error) {
      console.error("Register error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Unable to register. Please try again later.";
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-modal">
      <div className="modal-container">
        <button className="close-btn" onClick={onClose}>X</button>

        <div className="logo-placeholder">
          <img className="logo" src={logo} alt="Avrnhh Logo" />
        </div>

        <h2 className="headline">
          {isRegister ? "Create your account" : "Welcome back"}
        </h2>

        <div className="input-group">
          {isRegister && (
            <input
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          )}
        </div>

        <div className="input-group">
          <input
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
          />
        </div>

        <div className="input-group">
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          className="continue-btn"
          onClick={isRegister ? handleRegister : handleLogin}
          disabled={loading}
        >
          {loading
            ? isRegister
              ? "Registering..."
              : "Logging in..."
            : isRegister
            ? "Register"
            : "Login"}
        </button>

        <p className="toggle-text">
          {isRegister ? (
            <>
              Already have an account?{" "}
              <span className="toggle-link" onClick={() => setIsRegister(false)}>
                Login
              </span>
            </>
          ) : (
            <>
              Don’t have an account?{" "}
              <span className="toggle-link" onClick={() => setIsRegister(true)}>
                Sign Up
              </span>
            </>
          )}
        </p>

        <p className="terms-text">
          By continuing, you agree to our{" "}
          <a href="#">Terms of Service</a> & <a href="#">Privacy Policy</a>
        </p>
      </div>
    </div>
  );
};

export default LoginModal;
